import { render } from "./tenants.vue?vue&type=template&id=7f174163"
import script from "./tenants.vue?vue&type=script&lang=ts"
export * from "./tenants.vue?vue&type=script&lang=ts"
script.render = render

export default script